import React from 'react';
import { Row, Col, Divider } from 'antd';
import moment from 'moment';

import { Texto } from '../Texto';

import * as S from '../styles';

export function Arrendatario({ arrendatario = {} }) {
  const titleSecao =
    `Dados cadastrais ${arrendatario?.detalheTipoCadastro}` || '-';

  return (
    <Col span={24}>
      <Row gutter={[2, 8]} justify="space-between">
        <Col span={24}>
          <Divider
            style={{
              marginBottom: '16px',
              padding: 0,
              border: '1px solid #C2CCD1',
            }}
          />
        </Col>
      </Row>
      <Row justify="center" style={{ margin: '16px 0' }}>
        <Col span={24}>
          <S.TituloDetalheVeiculo>{titleSecao}</S.TituloDetalheVeiculo>
        </Col>
      </Row>
      {arrendatario?.pessoaFisicaCadastro?.cpf ? (
        <ArrendatarioPF arrPF={arrendatario} />
      ) : (
        <ArrendatarioPJ arrPJ={arrendatario} />
      )}
    </Col>
  );
}

function ArrendatarioPF({ arrPF = {} }) {
  return (
    <Col span={24}>
      <Row
        justify="space-between"
        style={{ marginBottom: '16px' }}
        gutter={[0, 8]}
      >
        <Col span={4}>
          <Texto
            titulo="Nome"
            valor={arrPF?.pessoaFisicaCadastro?.nome || '-'}
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="CPF"
            valor={arrPF?.pessoaFisicaCadastro?.cpfFormatado || '-'}
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="Data de Nascimento"
            valor={
              arrPF?.pessoaFisicaCadastro?.dataNascimento
                ? moment(arrPF?.pessoaFisicaCadastro?.dataNascimento).format(
                    'DD/MM/YYYY'
                  )
                : '-'
            }
          />
        </Col>
        <Col span={4}>
          <Texto titulo="Telefone" valor={arrPF?.telefone || '-'} />
        </Col>
        <Col span={4}>
          <Texto
            titulo="Naturalidade"
            valor={arrPF?.pessoaFisicaCadastro?.naturalidade || '-'}
          />
        </Col>
      </Row>
      <Row
        justify="space-between"
        style={{ marginBottom: '16px' }}
        gutter={[0, 8]}
      >
        <Col span={4}>
          <Texto
            titulo="Nome da mãe"
            valor={arrPF?.pessoaFisicaCadastro?.nomePai || '-'}
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="Nome do pai"
            valor={arrPF?.pessoaFisicaCadastro?.nomeMae || '-'}
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="Numero do PIS"
            valor={arrPF?.pessoaFisicaCadastro?.numeroPIS || '-'}
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="Numero do RG"
            valor={arrPF?.pessoaFisicaCadastro?.numeroRG || '-'}
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="UF RG"
            valor={arrPF?.pessoaFisicaCadastro?.ufrg || '-'}
          />
        </Col>
      </Row>
      <Row justify="start" style={{ marginBottom: '16px' }} gutter={[0, 8]}>
        <Col span={5}>
          <Texto
            titulo="RNTRC"
            valor={arrPF?.proprietarioCadastro?.rntrc || '-'}
          />
        </Col>
        <Col span={5}>
          <Texto
            titulo="Validade RNTRC"
            valor={
              (arrPF?.proprietarioCadastro?.vencimentoRNTRC &&
                moment(arrPF?.proprietarioCadastro?.vencimentoRNTRC).format(
                  'DD/MM/YYYY'
                )) ||
              '-'
            }
          />
        </Col>
        <Col span={5}>
          <Texto
            titulo="UF endereço"
            valor={arrPF?.dadosEndereco?.uf || '-'}
          />
        </Col>
        <Col>
          <Texto titulo="Endereço" valor={arrPF?.endereco || '-'} />
        </Col>
      </Row>
    </Col>
  );
}

function ArrendatarioPJ({ arrPJ = {} }) {
  return (
    <Col span={24} style={{ margin: '24px 0' }}>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col span={4}>
          <Texto
            titulo="Nome Fantasia"
            valor={arrPJ?.pessoaJuridicaCadastro?.nomeFantasia || '-'}
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="Razão social"
            valor={arrPJ?.pessoaJuridicaCadastro?.razaoSocial || '-'}
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="Inscrição estadual"
            valor={arrPJ?.pessoaJuridicaCadastro?.inscricaoEstadual || '-'}
          />
        </Col>
        <Col span={4}>
          <Texto
            titulo="CNPJ"
            valor={arrPJ?.pessoaJuridicaCadastro?.cnpjFormatado || '-'}
          />
        </Col>
        <Col span={4}>
          <Texto titulo="Telefone" valor={arrPJ?.telefone || '-'} />
        </Col>
      </Row>
      <Row justify="start" gutter={[2, 8]} style={{ marginBottom: '16px' }}>
        <Col span={5}>
          <Texto
            titulo="RNTRC"
            valor={arrPJ?.proprietarioCadastro?.rntrc || '-'}
          />
        </Col>
        <Col span={5}>
          <Texto
            titulo="Validade RNTRC"
            valor={
              (arrPJ?.proprietarioCadastro?.vencimentoRNTRC &&
                moment(arrPJ?.proprietarioCadastro?.vencimentoRNTRC).format(
                  'DD/MM/YYYY'
                )) ||
              '-'
            }
          />
        </Col>
        <Col span={5}>
          <Texto
            titulo="UF endereço"
            valor={arrPJ?.dadosEndereco?.uf || '-'}
          />
        </Col>
        <Col>
          <Texto titulo="Endereço" valor={arrPJ?.endereco || '-'} />
        </Col>
      </Row>
    </Col>
  );
}
